import { weenatIntl } from '@weenat/wintl';
import moment from 'moment-timezone';
import TimeSteps from '../../enums/TimeSteps';
/**
 * WARNING use only for test timezone should be always define
 */
export const defaultTimezone = 'Europe/Paris';
/**
 * Gets all the days in between the given dates
 */
function eachDayOfPeriod({ start, end }) {
    const now = moment(start).clone();
    const dates = [];
    while (now.isSameOrBefore(end)) {
        dates.push(now.toDate());
        now.add(1, 'days');
    }
    return dates;
}
/**
 * Gets all the month (as numbers) in between the given dates
 */
export function getFirstDayOfEachMonthInPeriod({ period, timezone }) {
    const cursor = moment.tz(period.start, timezone).clone();
    const firstDays = [];
    while (cursor.isSameOrBefore(moment.tz(period.end, timezone))) {
        firstDays.push(cursor.toDate());
        cursor.add(1, 'month').startOf('month');
    }
    return firstDays;
}
export function fromDateToMonth(date) {
    return { index: date.getMonth(), year: date.getFullYear() };
}
/**
 * Gets all the days inside the month of the given date
 */
function getDaysOfTheMonth({ index, year, timezone }) {
    return eachDayOfPeriod({
        start: moment().tz(timezone).set('month', index).set('year', year).startOf('month').toDate(),
        end: moment().tz(timezone).set('month', index).set('year', year).endOf('month').toDate()
    });
}
/**
 * Gets all the days in a month plus the ones from the week before or after said month
 */
export function getAllWeeksOfMonth({ index, year, timezone }) {
    const firstDayMonth = moment().tz(timezone).set('month', index).set('year', year).startOf('month');
    const lastDayMonth = moment().tz(timezone).set('month', index).set('year', year).endOf('month');
    let daysBefore = [];
    let daysAfter = [];
    // If the first day of the month isn't a monday we get the days until the previous monday
    if (firstDayMonth.get('day') !== 1) {
        daysBefore = eachDayOfPeriod({
            start: firstDayMonth.clone().startOf('week').toDate(),
            end: moment(firstDayMonth).subtract(1, 'day').toDate()
        });
    }
    // If last day isn't a sunday we get the days until the next sunday
    if (lastDayMonth.get('day') !== 0) {
        daysAfter = eachDayOfPeriod({
            start: lastDayMonth.clone().add(1, 'day').toDate(),
            end: lastDayMonth.clone().endOf('week').toDate()
        });
    }
    return [
        ...daysBefore,
        ...getDaysOfTheMonth({
            index,
            year,
            timezone
        }),
        ...daysAfter
    ];
}
/**
 * Gets all the first letters of any week days
 */
export const firstLettersOfWeekDays = () => {
    const today = moment(new Date(Date.now()));
    const days = [];
    for (let i = 0; i <= 6; i = i + 1) {
        days.push(moment(today).weekday(i).format('ddd').slice(0, 1));
    }
    return days;
};
/**
 * Helper to transform timestamps into moments without any typing errors
 */
export const timestampToMoment = (timestamp, timezone) => {
    let finalMoment;
    const tz = timezone || moment.tz.guess();
    if (typeof timestamp === 'string') {
        finalMoment = moment.unix(parseInt(timestamp, 10)).tz(tz);
    }
    else {
        finalMoment = moment.unix(timestamp).tz(tz);
    }
    return finalMoment;
};
/** Convert a Date to a timestamp string */
export const dateToTimestamp = (date, timezone) => moment.tz(date, timezone).unix().toString();
export const getDateFormatPerTimeSteps = (timeStep) => {
    let result = weenatIntl.t('formats.date');
    switch (timeStep) {
        case TimeSteps.per6Hours:
        case TimeSteps.per4Hours:
        case TimeSteps.perHalfHours:
        case TimeSteps.perHours:
        case TimeSteps.perQuarterHours:
        case TimeSteps.maximum:
            result = weenatIntl.t('formats.datetime_chart');
            break;
        case TimeSteps.perMonth:
            result = weenatIntl.t('formats.month');
            break;
    }
    return result;
};
export const areDatesChronological = (dates) => {
    let areChronological = false;
    dates.forEach((date, i) => {
        if (i + 1 <= dates.length - 1) {
            const followingDate = dates[i + 1];
            areChronological =
                date.getTime() < followingDate.getTime() && date.getTime() !== followingDate.getTime();
        }
    });
    return areChronological;
};
